// ag-grid-react v30.2.1
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeansContext = void 0;
var react_1 = __importDefault(require("react"));
exports.BeansContext = react_1.default.createContext({});
